import React, { Component } from 'react'; //different
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
//import './style.css';
import Main from './main';
import Casino from './casino';
import NavMenu from './navmenu';
import Slot from './slot';
import Sport from './sport';
import Fising from './fising';
import Banner from './banner';
import TextSlider from './textslide';
class App extends Component {
  render() {
    return (

      <>
        <div>
          <br />
          <br />
          <br />
        </div>
        <div>
          <TextSlider />
        </div>

        <div style={{ marginTop: "7px" }}>
          <Banner />
        </div>

        {/**/}
      </>


    );
  }
}

export default App;
